import { useState, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose, faPlus } from "@fortawesome/free-solid-svg-icons";
import { faEdit, faTrashAlt } from "@fortawesome/free-regular-svg-icons";

import { FormInput } from "../../components/forms/form-input";
import { SiteHeader } from "../../components/header/header";
import { DropdownInput } from "../../components/forms/dropdown";
import { brands, categories } from "../../_helpers/mock-data";
import { PropertyInput } from "../../components/forms/property-input";
import { isEmpty, isNull } from "../../_helpers/isNull";
import { useAuthentication } from "../../../services/authentication/authentication.context";
import { useProduct } from "../../../services/products/product.context";
import { LoadingIndicator } from "../../components/utils/loader";
import { AppAlert } from "../../components/utils/alert";

export const ProductAddForm = () => {

    const { token } = useAuthentication();
    const { addNewProductImage, removeProductImage, addNewProduct, loading } = useProduct();
    const [openNext, setOpenNext] = useState(false);
    const [productData, setProductData] = useState({
        designation: '',
        images: [],
        category: '',
        properties: [],
        cost: '',
        brand: ''
    });
    const [propCaption, setPropCaption] = useState('');
    const [propValue, setPropValue] = useState('');

    const [previews, setPreviews] = useState([]);

    const [onAlert, setOnAlert] = useState();

    const { designation, images, category, properties, cost, brand } = productData;

    const bttnRef = useRef();

    const handleUpdate = (prop) => {
        setPropCaption(Object.keys(prop)[0]);
        setPropValue(Object.values(prop)[0]);
        setProductData((d) => ({
            ...d, properties: d.properties.filter((v) => {
                return Object.keys(v)[0] !== Object.keys(prop)[0] && Object.values(v)[0] !== Object.values(prop)[0];
            })
        }))
    }

    const handleRemove = (prop) => {
        setProductData((d) => ({
            ...d, properties: d.properties.filter((v) => {
                return Object.keys(v)[0] !== Object.keys(prop)[0] && Object.values(v)[0] !== Object.values(prop)[0];
            })
        }))
    }

    const handleInput = (e) => {
        e.preventDefault();
        setProductData((data) => ({ ...data, [e.target.name]: e.target.value }));
    }

    const handleAddImage = async (e) => {
        const resp = await addNewProductImage(e.target.files[0]);
        if (resp?.error) {
            setOnAlert({
                caption: 'Upload Error!',
                message: resp?.error,
                accept: "Ok",
                onAccept: () => setOnAlert()
            });
            return;
        }
        const fileUrl = resp?.uri;
        console.log(resp);
        setProductData((data) => ({ ...data, images: [...images, fileUrl] }));
        setPreviews((prev) => ([
            ...prev, {
                url: fileUrl,
                temPath: URL.createObjectURL(e.target.files[0])
            }]));
    }

    const handleRemoveImage = async (fileUri) => {
        const resp = await removeProductImage(fileUri);
        if (resp?.error) {
            alert("Image removel failed");
            return console.log({ error: resp?.error });
        }
        if (resp?.success) {
            setPreviews((prev) => prev.filter((obj) => obj.url !== fileUri))
            setProductData((d) => ({ ...d, images: d.images.filter((uri) => uri !== fileUri) }))
            return alert("Image removed!");
        }
    }

    const handleAddProduct = async (data, token) => {
        //validate data
        const strValues = ['designation', 'category', 'brand', 'cost'];
        const arrValues = ['properties', 'images'];

        //check for null values on strings and empty arrays for input 
        const invalidStrVal = strValues.some((val) => isNull(productData[val]));
        const inValidArrVal = arrValues.some((arr) => isEmpty(productData[arr]));

        //reject invalid input
        if (inValidArrVal || invalidStrVal) {
            setOnAlert({
                caption: 'Invalid input!',
                message: 'Please provide all the required information!',
                accept: "Ok",
                onAccept: () => setOnAlert()
            });
            return;
        }

        const resp = await addNewProduct(data, token);
        if (resp?.error) {
            setOnAlert({
                caption: "Error",
                message: 'Something went wrong!',
                accept: "Ok",
                onAccept: () => setOnAlert()
            });
            return console.log(resp);
        }

        setOnAlert({
            caption: "Success!",
            message: resp?.message,
            accept: "Ok",
            onAccept: () => {
                setOnAlert();
                window.location.reload();
            }
        })

    }

    const categoryNames = categories?.map((obj) => obj.name);
    const brandNames = brands.map((obj) => obj.name);

    return (
        <div className="page-body">
            <SiteHeader pageTitle={"Add a product"} />
            {loading && <LoadingIndicator />}
            {onAlert && (
                <AppAlert
                    caption={onAlert.caption}
                    message={onAlert.message}
                    accept={onAlert.accept}
                    reject={onAlert.reject}
                    onClose={() => setOnAlert()}
                    onAcept={onAlert.onAccept}
                    onReject={onAlert.onReject}
                />
            )}
            <div className="form-conatiner add-product-form-container">
                <div className="slogan-1 login-cap">
                    Add a product
                </div>
                {!openNext ?
                    <form
                        className="initial-form app-form"
                        onSubmit={(e) => e.preventDefault()}
                    >
                        <div className="sub-form-caption">
                            Upload product images (4 max)
                        </div>
                        <div className="images-box">
                            <button
                                className="img-add-button"
                                onClick={(e) => {
                                    e.preventDefault();
                                    if (previews?.length >= 4) {
                                        alert("Maximum uploads attained! You can only add a maximum of four images per product.");
                                        return;
                                    }
                                    bttnRef.current.click()
                                }}
                            >
                                <FontAwesomeIcon icon={faPlus} />
                            </button>
                            <input
                                type="file"
                                className="image-input"
                                onChange={(e) => {
                                    e.preventDefault();
                                    handleAddImage(e)
                                }}
                                ref={bttnRef}
                            />
                            {previews?.map((prev, k) => (
                                <div className="preview-unit" key={k}>
                                    <button
                                        className="remove-img"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleRemoveImage(prev?.url);
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faClose} />
                                    </button>
                                    <img src={prev?.temPath} alt="" className="preview-img" />
                                </div>
                            ))}
                        </div>
                        <div className="sub-form-caption">
                            Product details
                        </div>
                        <FormInput
                            value={designation}
                            label={'Product designation'}
                            name={'designation'}
                            onChange={(e) => handleInput(e)}
                            type={'text'}
                            required={true}
                        />
                        <DropdownInput
                            value={category}
                            defaultValue={"--- Select product category ---"}
                            onChange={(e) => handleInput(e)}
                            name={'category'}
                            data={categoryNames}
                        />
                        <DropdownInput
                            value={brand}
                            defaultValue={"--- Select product brand ---"}
                            onChange={(e) => handleInput(e)}
                            name={'brand'}
                            data={brandNames}
                        />
                        <FormInput
                            value={cost}
                            label={'Product price'}
                            name={'cost'}
                            onChange={(e) => handleInput(e)}
                            type={'number'}
                            required={true}
                        />
                        <div className="image-input-conatiner">

                        </div>
                        <button
                            className="form-button"
                            onClick={() => setOpenNext(true)}
                        >
                            Next
                        </button>
                    </form> :
                    <form
                        className="initial-form app-form"
                        onSubmit={(e) => e.preventDefault()}
                    >
                        <div className="sub-form-caption">
                            Product properties
                        </div>
                        <div className="properties-list">
                            {properties?.map((prop, k) => (
                                <div className="prop-list-row" key={k}>

                                    <div className="prop-data-box">
                                        <span className="prop-title">{Object.keys(prop)[0]}</span>
                                        <span className="prop-data">{Object.values(prop)[0]}</span>
                                    </div>

                                    <div className="prop-edit-box">
                                        <button
                                            className="edit-bttn edit"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                handleUpdate(prop);
                                            }}
                                        >
                                            <FontAwesomeIcon icon={faEdit} />
                                        </button>
                                        <button
                                            className="edit-bttn del"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                handleRemove(prop);
                                            }}
                                        >
                                            <FontAwesomeIcon icon={faTrashAlt} />
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <PropertyInput
                            propCaption={propCaption}
                            propValue={propValue}
                            onChangeCaption={(e) => setPropCaption(e.target.value)}
                            onChangeValue={(e) => setPropValue(e.target.value)}
                            onAddProp={(e) => {
                                e.preventDefault();
                                if (isNull(propCaption) || isNull(propValue)) {
                                    return alert('Null values are not allowed for property caption or description');
                                }
                                setProductData((d) => ({
                                    ...d,
                                    properties: [...d.properties, { [propCaption]: propValue }]
                                }));
                                setPropCaption('');
                                setPropValue('');
                            }}
                        />
                        <button
                            className="form-button"
                            onClick={() => setOpenNext(false)}
                        >
                            Previous
                        </button>
                        <button
                            className="form-button"
                            onClick={async () => {
                                await handleAddProduct(productData, token);
                                console.log({ token });
                            }}
                        >
                            Submit
                        </button>
                    </form>
                }
            </div>
        </div>
    )
}